import { render } from "./LegislationForwardBtn.vue?vue&type=template&id=6961f76c"
import script from "./LegislationForwardBtn.vue?vue&type=script&lang=js"
export * from "./LegislationForwardBtn.vue?vue&type=script&lang=js"

import "./LegislationForwardBtn.vue?vue&type=style&index=0&id=6961f76c&lang=css"

import exportComponent from "/builds/cu2207/business/produkter.dk/pfp-public-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__